import { useEffect, useState } from "react";
import TopFive from "./TopFive/TopFive";
import TopFiveMostPopSeries from "./TopFiveMostPopSeries/TopFiveMostPopSeries";
import Carousel from "../Carousel/Carousel";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import SlidingHeader from "../SlidingHeader/SlidingHeader";
import "./PageLanding.scss";
import { Link, redirect, useLocation, useNavigate } from "react-router-dom";

function PageLanding() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.state?.section) {
      const el = document.getElementById(location.state.section);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  const [topFiveData, setTopFiveData] = useState({
    mostPop: [],
    newArrival: [],
    onhand: [],
    preorder: [],
  });

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}api/product/get-all-top-five`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setTopFiveData(data);
      })
      .catch((err) => console.error("Failed to load top five:", err));
  }, []);
  const animeSeriesData = [
    {
      seriesId: "goku",
      imageLogo: "dragonball-logo.png",
      imageBack: [{ image: "goku-back.png", opacity: "0.5" }],
      imageFront: "goku-kid.png",
      colorBackground: [{ Degrees: "180", Colors: ["#ffde59", "#ff914d"] }],
      seriesName: "DRAGONBALL",
    },
    {
      seriesId: "naruto",
      imageLogo: "narutologo.png",
      imageBack: [{ image: "narutoback.png", opacity: "0.5" }],
      imageFront: "narutokid.png",
      colorBackground: [{ Degrees: "180", Colors: ["#ff3131", "#ff914d"] }],
      seriesName: "NARUTO",
    },
    {
      seriesId: "onepiece",
      imageLogo: "onepiecelogo.png",
      imageBack: [{ image: "luffyback.png", opacity: "0.5" }],
      imageFront: "luffykid.png",
      colorBackground: [{ Degrees: "90", Colors: ["#cdffd8", "#94b9ff"] }],
      seriesName: "ONE PIECE",
    },
    {
      seriesId: "HunterXHunter",
      imageLogo: "hxhlogo.png",
      imageBack: [{ image: "hxhback.png", opacity: "0.5" }],
      imageFront: "gonxkilluakid.png",
      colorBackground: [
        { Degrees: "180", Colors: ["#b7b8b8", "#90e46d", "#38bb00"] },
      ],
      seriesName: "HUNTERXHUNTER",
    },
    {
      seriesId: "MyHeroAcademia",
      imageLogo: "mhalogo.png",
      imageBack: [{ image: "dekuback.png", opacity: "0.5" }],
      imageFront: "dekukid.png",
      colorBackground: [{ Degrees: "180", Colors: ["#ed7411", "#61cb68"] }],
      seriesName: "MY HERO ACADEMIA",
    },
  ];
  return (
    <main>
      <SlidingHeader />
      <Navbar />
      <Carousel />

      {/* ✅ Render each TopFive only if exactly 5 items */}
      {topFiveData.newArrival.length === 5 && (
        <TopFive
          data={topFiveData.newArrival}
          titleName="NEW ARRIVAL"
          state={"newest"}
          id="NewArrival"
        />
      )}

      {topFiveData.mostPop.length === 5 && (
        <TopFive
          data={topFiveData.mostPop}
          titleName="MOST POPULAR"
          state={"most-popular"}
          id="MostPop"
        />
      )}

      {topFiveData.onhand.length === 5 && (
        <TopFive
          data={topFiveData.onhand}
          titleName="ON-HAND"
          filter={"onhand"}
          id="Onhand"
        />
      )}

      {topFiveData.preorder.length === 5 && (
        <TopFive
          data={topFiveData.preorder}
          titleName="PRE-ORDER"
          filter={"preorder"}
          id="Preorder"
        />
      )}

      <TopFiveMostPopSeries
        data={animeSeriesData}
        titleName="Anime Series"
        id="AnimeSeries"
      />

      <Footer />
    </main>
  );
}

export default PageLanding;
